import { type Theme, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export interface UseResponsiveProps {
  query: 'up' | 'down' | 'between' | 'only';
  start: keyof Theme['breakpoints']['values'];
  end?: keyof Theme['breakpoints']['values'];
}

export default function useResponsive({ query, start, end }: UseResponsiveProps): boolean {
  const theme = useTheme();

  const mediaUp = useMediaQuery(theme.breakpoints.up(start));
  const mediaDown = useMediaQuery(theme.breakpoints.down(start));
  const mediaOnly = useMediaQuery(theme.breakpoints.only(start));

  if (query === 'up') {
    return mediaUp;
  }

  if (query === 'down') {
    return mediaDown;
  }

  if (query === 'between' && end) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const mediaBetween = useMediaQuery(theme.breakpoints.between(start, end));
    return mediaBetween;
  }

  return mediaOnly;
}
